import { basename, extname, join } from "path";

export const getFileNameWithExtension = (path: string): string => {
    return basename(path); // returns "filename.ext"
};

export const getFileExtension = (path: string): string => {
    return extname(path).slice(1); // returns "ext"
};

export const getFileName = (path: string): string => {
    return basename(path, extname(path)); // returns "filename"
};

export const getFileExtensionWithDot = (path: string): string => {
    return extname(path); // returns ".ext"
};

export const joinPathWithFileName = (path: string, fileName: string): string => {
    return join(path, fileName); // returns "/new-folder/filename.ext"
};
